export const DIALOG_SURFACE = '#F5F7FC';
export const DIALOG_BORDER = 'rgba(23, 32, 51, 0.08)';

export const FOLIO_EDGE = 'rgba(77, 91, 255, 0.72)';
export const INK_MUTED = 'rgba(23, 32, 51, 0.64)';
export const INK_SOFT = 'rgba(23, 32, 51, 0.48)';

export const STARTER_PROMPTS = [
	{
		label: 'Summarise this client',
		prompt: 'Summarise this client',
	},
	{
		label: 'Draft a renewal email',
		prompt: 'Draft a renewal email',
	},
	{
		label: 'What documents are missing?',
		prompt: 'What documents are missing?',
	},
	{
		label: 'Summarise recent notes and correspondence',
		prompt: 'Summarise recent notes and correspondence',
	},
	{
		label: 'Prepare a broker briefing',
		prompt: 'Prepare a broker briefing',
	},
	{
		label: 'Explain the current policy position',
		prompt: 'Explain the current policy position',
	},
	{
		label: 'Suggest next task',
		prompt: 'Suggest the single best next task for the broker based on the current context. Keep it operational and actionable. Respond using exactly these headings: Task title:, Why:, Recommended due date:, Priority:, Task details:. Then cite the supporting sources you used.',
	},
];
